import { forwardRef, type PropsWithChildren } from 'react';

import { Link } from '@/domains/core/routing/components/Link';
import { routes } from '@/domains/core/routing/routes/routes.default';
import { createURL } from '@/domains/core/routing/URLParser';
import { articlePathToSlugId } from '@/domains/productDiscovery/ProductPage/utils/productUrl/articlePathToSlugId';

export interface ProductCardLinkProps {
  url: string;
  onClick?(): void;
  className?: string;
  title?: string;
  favourite?: boolean;
}

export const ProductCardLink = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<ProductCardLinkProps>
>(({ children, url, title, className, onClick }, ref) => (
  <Link
    ref={ref}
    className={className}
    title={title}
    href={createURL(routes.product, articlePathToSlugId(url))}
    onClick={onClick}
    data-testid="productCardListing"
  >
    {children}
  </Link>
));
